import React from "react";
import { themeFor } from "../utils/theme";
import { phonesFor } from "../config/phoneConfig";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { CookieBanner } from "./CookieBanner";
import { StickyBar } from "./StickyBar";

// Gabarit commun : en-tête, contenu, pied de page, barre d'appel et bandeau cookies.
// Les numéros dépendent de la page (une page marque peut avoir son propre numéro).
export function Layout({ provider, children }) {
  const phones = phonesFor(provider);
  return (
    <div className="page" style={themeFor(provider)}>
      <Header />
      <main>{children}</main>
      <Footer phones={phones} />
      <CookieBanner />
      <StickyBar phones={phones} />
    </div>
  );
}
